import React from "react";
import { FeedbackOnlyText } from "../../../../../components/FeedbackOnlyText";
import { observer } from "mobx-react-lite";

import { ReactComponent as AttentionIcon } from "../../../../../assets/icons/attention.svg";
import { useNavigateCustom } from "../../../../../hooks";

interface IProps {
	onChangeInfoClick: VoidFunction;
}

const feedbackText = {
	title: "Não conseguimos validar seu número",
	description:
          "Você precisa informar o CPF do titular do número informado ou um número Vivo que esteja em seu nome",
	type: "numberNotValidated",
	link: {},
	warnings: [],
	button: {
		primaryButtonText: "Alterar informações",
		secondaryButtonText: "Ir pro início",
	},
};

export const IsNotPhoneOwnerFeedback: React.FC<IProps> = observer((props) => {
	const { onChangeInfoClick } = props;
	const navigate = useNavigateCustom();

	const handleOnClickPrimaryButton = () => {
		onChangeInfoClick();
	};

	const handleOnClickSecondaryButton = () => {
		navigate("/");
	};

	return (
		<FeedbackOnlyText
			data={feedbackText}
			primaryButton={{
				title: feedbackText.button.primaryButtonText,
				onClick: handleOnClickPrimaryButton,
			}}
			secondaryButton={{
				title: feedbackText.button.secondaryButtonText,
				onClick: handleOnClickSecondaryButton,
				variant: "ghost",
			}}
			icon={{
				icon: AttentionIcon,
				w: 58,
				color: "error",
			}}
		/>
	);
});
